import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export default function SideProductCartSummary(props) {
  const history = useHistory();

  // PROPS COMING FROM SideProductModalContent
  const { addedSkus, setScrollHeight, width } = props;

  // CALCULATE IF THERE IS A SAVING
  const [hasSaving, setHasSaving] = useState(0);
  useEffect(() => {
    if (addedSkus?.length > 0) {
      setHasSaving(
        addedSkus.reduce((a, c) => a + c.priceForOne, 0) -
          addedSkus.reduce((a, c) => a + c.price, 0)
      );
    }
  }, [addedSkus]);

  return (
    <>
      <button
        className={width < 800 ? "primary w90p" : "primary w40p"}
        onClick={() => {
          history.push("/sepet");
          setScrollHeight("/urun");
        }}
      >
        Sepete Git
      </button>
      {hasSaving > 0 && (
        <p className="fs1125 lh1-5">
          Toplam set tutarı:{" "}
          <strike className="red-col">
            {addedSkus.reduce((a, c) => a + c.priceForOne, 0)} TL
          </strike>
        </p>
      )}
      <p className="fs1125 lh1-5">
        Ödeme tutarı:{" "}
        <span>{addedSkus.reduce((a, c) => a + c.price, 0)} TL</span>
      </p>
      {hasSaving > 0 && (
        <p className="fs1125 lh1-5">
          Tasarrufunuz:{" "}
          <span className="green">
            {(
              addedSkus.reduce((a, c) => a + c.priceForOne, 0) -
              addedSkus.reduce((a, c) => a + c.price, 0)
            ).toFixed(2)}{" "}
            TL
          </span>
        </p>
      )}
    </>
  );
}
